import './App.css';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'; // Import Router components
import Navbar from './component/Navbar/Navbar';
import Main from './component/Main/Main';
import Centralization from './component/Centralization/Centralization';
import EsgPlatform from './component/EsgPlatfrom/EsgPlatform';
// import IoT from './component/IoT/IoT'; // IoT Solutions page
import Aiplatform from './component/Aiplatform/Aiplatform';
import Sitereference from './component/Sitereference/Sitereference';
// import Successstory from './component/Successstory/Successstory';
import Annoument from './component/Annoument/Annoument';
import Footer from './component/Footer/Footer';
import IotSolution from './component/Platform/IotSolution/IotSolution'
import EMS from './component/Platform/IotSolution/EMS/EMS'
import BMS from './component/Platform/IotSolution/BMS/BMS'
import AirQuality from './component/Platform/IotSolution/AirQuality/AirQuality'
import FireAlarm from './component/Platform/IotSolution/FireAlarm/FireAlarm'
import ACOptimized from './component/Platform/IotSolution/ACOptimized/ACOptimized'
import Wastewater from './component/Platform/IotSolution/Wastewater/Wastewater'
import Rectifier from './component/Platform/IotSolution/Rectifier/Rectifier'
import Oee from './component/Platform/IotSolution/Oee/Oee'
import SolarPlant from './component/Platform/IotSolution/SolarPlant/SolarPlant'
import VehicleTracking from './component/Platform/IotSolution/VehicleTracking/VehicleTracking'
import SmartMeeting from './component/Platform/IotSolution/SmartMeeting/SmartMeeting'
import CFO from './component/Platform/IotSolution/CFO/CFO'
import SustainX from './component/SustainX/SustainX'
import AllProduct from './component/AllProduct/AllProduct'
import AllService from './component/AllService/AllService'
import AboutUs from './component/AboutUs/AboutUs'
import News from './component/News/News'
import DetailNews from './component/detailNews/DetailNews';
import Carbon from './component/Carbon/Carbon';
import '@fortawesome/fontawesome-free/css/all.min.css';

function App() {
  return (
    <div className="App">
      <I18nextProvider i18n={i18n}>
        <Router>
          <Navbar />
          <Routes>
            <Route path="/" element={
              <>
                <Main />
                <EsgPlatform />
                <Carbon />
                <Centralization />
                {/* <IoT /> */}
                <Aiplatform />
                <Sitereference />
                {/* <Successstory /> */}
                <Annoument />
              </>
            } />
            <Route path="/sustain-x" element={<SustainX />} />
            <Route path="/iot-solutions" element={<IotSolution />} />
            <Route path="/ems" element={<EMS />} />
            <Route path="/bms" element={<BMS />} />
            <Route path="/aqi" element={<AirQuality />} />
            <Route path="/fire-alarm" element={<FireAlarm />} />
            <Route path="/ac-optimized" element={<ACOptimized />} />
            <Route path="/wastewater" element={<Wastewater />} />
            <Route path="/rectifier" element={<Rectifier />} />
            <Route path="/oee" element={<Oee />} />
            <Route path="/solarplant" element={<SolarPlant />} />
            <Route path="/vehicletracking" element={<VehicleTracking />} />
            <Route path="/smartmeeting" element={<SmartMeeting />} />
            <Route path="/carbonFootprint" element={<CFO />} />
            <Route path="/all-product" element={<AllProduct />} />
            <Route path="/all-service" element={<AllService />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/news&events" element={<News />} />
            <Route path="/detailNews/:id" element={<DetailNews />} />
          </Routes>
          <Footer />
        </Router> 
      </I18nextProvider>
    </div>
  );
}

export default App;
